import "./hero_text_image.scss";
import swiper from "../js/slider";

const swiperSelectorString = "section.hero .swiper";
const options = {
    spaceBetween: 20,
    autoHeight: false,
    slidesPerView: 1,
    rewind: true,
    // centeredSlides: true,
    grabCursor: true,
    // loop: true,
    // loopAddBlankSlides: true,
    // setWrapperSize: true,
};
console.log({ swiper, options });
swiper(swiperSelectorString, options);
